export default "__VITE_ASSET__e0e564c0__"